<nb-card>
  <nb-card-body [nbSpinner]="isLoading">
    <mat-tab-group active class="tab" #tabGroup selectedIndex="0">
      <mat-tab i18n-tabTitle="@@Program" label="Program" tabindex="0" *ngIf="currentAccount | async">
        <ng-template mat-tab-label>
          <span class="fas fa-box-open"></span>
          <span class="ml-1">Packages & Subscriptions</span>
        </ng-template>
        <nb-card>
          <nb-card-body style="overflow-x: hidden">
            <app-patient-subscriptions></app-patient-subscriptions>
          </nb-card-body>
        </nb-card>
      </mat-tab>
      <mat-tab i18n-tabTitle="@@Program" label="Program" tabindex="1" *ngIf="currentAccount | async">
        <ng-template mat-tab-label>
          <span class="fas fa-file-invoice"></span>
          <span class="ml-1">Invoices</span>
        </ng-template>
        <nb-card>
          <nb-card-body style="overflow-x: hidden">
            <app-invoices></app-invoices>
          </nb-card-body>
        </nb-card>
      </mat-tab>
      <mat-tab i18n-tabTitle="@@Program" label="Program" tabindex="2" *ngIf="!isLoading">
        <ng-template mat-tab-label>
          <span class="fas fa-wrench"></span>
          <span class="ml-1">Settings</span>
        </ng-template>
        <nb-card>
          <nb-card-body style="overflow-x: hidden">
            <app-payment-settings></app-payment-settings>
          </nb-card-body>
        </nb-card>
      </mat-tab>
    </mat-tab-group>
  </nb-card-body>
</nb-card>
